export default __webpack_public_path__ + "media/zurb/img/legacy/clue/instructions-6-876203aec781d22f802b7c8bfda9b5a0.jpg";